<template>
    <div>
        <div class="d-flex flex-row justify-content-between">
            <div class="ob1-skeleton my-2">
                <div class="ob1-skeleton-white" style="width: 150px; height: 20px" />
            </div>
            <div class="ob1-skeleton my-2 d-md-none">
                <div class="ob1-skeleton-white" style="width: 70px; height: 20px" />
            </div>
        </div>
        <div v-for="x in 4" :key="'device-details-review-skeleton' + x" class="mb-3">
            <device-details-review-skeleton />
            <hr v-if="x < 4" class="separator separator--gray4 my-2">
        </div>
        <div class="d-flex flex-row justify-content-center mb-2">
            <div class="ob1-skeleton pe-5">
                <div class="ob1-skeleton-white" style="width: 120px; height: 70px" />
            </div>
            <div class="ob1-skeleton ps-5">
                <div class="ob1-skeleton-white" style="width: 120px; height: 70px" />
            </div>
        </div>
    </div>
</template>

<script>

import DeviceDetailsReviewSkeleton from "./DeviceDetailsReviewSkeleton.vue";

export default {
    name: "DeviceDetailsReviewsSkeleton",
    components: {DeviceDetailsReviewSkeleton},
}
</script>
